
import React from 'react';
import Layout from '@/components/layout/Layout';
import ProcurementForm from '@/components/procurements/form/ProcurementForm';

const ProcurementFormPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <ProcurementForm />
      </div>
    </Layout>
  );
};

export default ProcurementFormPage;
